import { render, staticRenderFns } from "./selectRegion.vue?vue&type=template&id=01cda701"
import script from "./selectRegion.vue?vue&type=script&lang=js"
export * from "./selectRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports